import {useParams} from "react-router";
import TableTopHistoryProvider from "@/tabletop/history/TableTopHistoryProvider.tsx";
import TableTopSelectionProvider from "@/tabletop/selection/TableTopSelectionProvider.tsx";
import SelectionRectangleProvider from "@/tabletop/selection/SelectionRectangleProvider.tsx";
import GameMasterViewSettingsProvider from "@/tabletop/gm/GameMasterViewSettingsProvider.tsx";
import GameMasterMapInteractionProvider from "@/tabletop/gm/GameMasterMapInteractionProvider.tsx";
import GameMasterTableTop from "@/tabletop/gm/GameMasterTableTop.tsx";
import TableTopRuntimeBoundary from "./TableTopRuntimeBoundary.tsx";
import {EncounterViewPortProvider} from "@/encounter/viewport/EncounterViewPortProvider.tsx";

export default function TableTopView() {
    const {id} = useParams();
    return <TableTopRuntimeBoundary encounterId={id}>
        <EncounterViewPortProvider>
            <TableTopSelectionProvider>
                <TableTopHistoryProvider>
                    <SelectionRectangleProvider>
                        <GameMasterViewSettingsProvider>
                            <GameMasterMapInteractionProvider>
                                <GameMasterTableTop/>
                            </GameMasterMapInteractionProvider>
                        </GameMasterViewSettingsProvider>
                    </SelectionRectangleProvider>
                </TableTopHistoryProvider>
            </TableTopSelectionProvider>
        </EncounterViewPortProvider>
    </TableTopRuntimeBoundary>;
}
